import './Footer.css';
import { Container, Row, Col } from 'reactstrap';

const Footer = () => {
  return (
    <footer className='footer text-light py-4'>
      <Container>
        <Row className="justify-content-md-center">
          <Col xs={6} md={4}>
            <h3>Elérhetőségek</h3>
            <p>
              <strong>Cím:</strong> 8600 Siófok, Borostyán utca 36.
            </p>
            <p>
              <strong>Telefonszám:</strong> 06-84/317-247<br />
              06-30/993-5463
            </p>
          </Col>
          <Col xs={6} md={3}>
            <h3>Nyitvatartás</h3>
            <p>
              H-P: 09:00 - 17:00<br />
              Szombat: 09:00 - 12:00<br />
              Vasárnap és ünnepnapokon zárva
            </p>
          </Col>
          <Col xs={6} md={5}>
            <h5 className='contact'>Térkép</h5>
            <div className='map-container'>
              <iframe
                src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2726.6196373875114!2d18.02447817601398!3d46.89053097113305!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4769bf5652e91e23%3A0x27028ee699896bd4!2zU2nDs2ZvaywgQm9yb3N0ecOhbiB1dGNhIDM2LCA4NjAw!5e0!3m2!1sen!2shu!4v1729439760038!5m2!1sen!2shu'
                className='rounded-map'
                title='Borostyán Location'
                allowFullScreen
                loading='lazy'
                referrerPolicy='no-referrer-when-downgrade'
              ></iframe>
            </div>
          </Col>
        </Row>
        <hr className='bg-light' />
        <Row>
          <Col md='12' className='text-center'>
            <p className='mb-0'>
              © {new Date().getFullYear()} Borostyán Szikvíz. All rights reserved. Made by Sió Creative I.T.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
